import React, {useState, useRef,useEffect, useContext} from 'react';
import {IProps} from './types';
import * as S from './styles';
import { ArrowDownIcon } from '@assets/icons/arrowDownIcon';
import { SortIcon } from '@assets/icons/sortIcon';
import { TemplatesContext } from '@utils/DOIgnition/TemplatesContext';
import { useSelector } from 'react-redux';
import { IAppState } from '@state/types';
import { UserAccessContext } from '@utils/DOIgnition/UserAccessContex';

const Order:React.FC<IProps> = (props) => {
  const{ sortByMenu, setSortByText, sortByText, value} = useContext(UserAccessContext);
  const [showMenu, setShowMenu]= useState(false);
  const [selected, setSelected]= useState(-1);
  const componentRef = useRef(null);
  const openNewTemplateState = useSelector<IAppState, IAppState["openNewTemplateState"]>((state) => state.openNewTemplateState).openNewTemplate;

  
  useEffect(() => {
      if(selected!==-1 && sortByMenu[selected]){
        setSortByText(sortByMenu[selected].text);
      }
      else setSortByText("");
  }, [selected])

  useEffect(() => {
    if(sortByText==="") {
      setSelected(-1);
    }
  }, [sortByText])

  const handleClickBtn = ()=>setShowMenu(!showMenu);

  const handleClickOption = (idx:number)=>{
    if(selected!==idx){
      setSelected(idx);
      setShowMenu(false);
      props.onClick(sortByMenu[idx].query);
    }
  }

  const handleClickOutside = (e: any)=> {
    if(componentRef && componentRef.current){
        const ref: any = componentRef.current
        if(!ref.contains(e.target))setShowMenu(false);
    }
  }

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [])

  /*useEffect(() => {
    if((value!=='')&&(location==="studio"))setSelected(0);
    else setSelected(-1);
  }, [value]);*/

  return (
    <S.Root ref={componentRef} style={{ marginRight: openNewTemplateState ? "55px" : ""}}>
      <S.Label>Sort by:</S.Label>
      <S.Btn onClick={handleClickBtn} selected={selected!=-1?true:false}>
        <SortIcon/>
        <ArrowDownIcon/>
      </S.Btn>
      <S.Menu style={{display: showMenu?'block':'none'}}>
          {sortByMenu.map((item: any, idx: number)=>
          <S.Option key={`op${idx}`} selected={idx===selected?true:false} onClick={()=>handleClickOption(idx)}>
            {item.title}
            {item.extra && <S.Extra>{item.extra}</S.Extra>}
          </S.Option>)}
      </S.Menu>
    </S.Root >
  );
}

export default Order;